export default {
  setAlerts: (state, payload) => (state.alerts = payload),
  setAlertsCount: (state, payload) => (state.alertsCount = payload),
  setAlert: (state, payload) => (state.alert = payload)
}
